var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from 'syf-component-library/ui/spacing';
import { useQueryClient } from '@tanstack/react-query';
import { PreferenceType, PrivacySettings } from '../../typings';
import SyfStorage from '../../../../helpers/SyfStorage';
import { CLICK_TRACKING_EVENT, DATA_OBJECT, DATA_REASON, DATA_TYPE } from '../../../../const/analytics';
import { ButtonContainer, ButtonWrapper, ChipIcon, CustomButton, CustomCheckBox, DeliveryIcons, DeliveryMethodWrapper, NotificationBarIcon, NotificationStatusBar } from './subcomponents';
import { MarketingSettingsCacheKey, NotificationStatus, PreferenceCategories, marketingPrivacySettingsCategories } from '../../config';
import { getDeliveryIcon, getDeliveryMethodTitle, getUpdatedPreferenceData } from './helper';
import getCamelCaseToSeparatedWords from '../../../../helpers/getCamelCaseToSeparateWords';
import PreferenceBodyContent from './PreferenceBody/PreferenceBodyContent';
import { ContentOrSpinner } from '../../../../ui/atoms/Buttons';
import { useMarketingSettingsMutation } from '../../services/marketingPrivacySettingsMutation';
import { FAL_CHECK_CIRCLE, FAS_CIRCLE_EXCLAMATION } from '../../../../const/iconProps';
import { AccountIdType } from '../../../../const/alertsConfig';
var MarketingPreferenceBody = function (_a) {
    var _b;
    var categoryKey = _a.categoryKey, marketingSettingsData = _a.marketingSettingsData, accountId = _a.accountId, config = _a.config;
    var queryClient = useQueryClient();
    var _c = useState(null), showNotificationBanner = _c[0], setShowNotificationBanner = _c[1];
    var _d = useState(false), isEditEnabled = _d[0], setEditEnabled = _d[1];
    var mutationKey = { accountId: accountId, accountIdType: AccountIdType.GUID };
    var updateMarketingPreference = useMarketingSettingsMutation({
        config: config,
        keyProps: mutationKey,
        mutationOptions: {
            onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(MarketingSettingsCacheKey(mutationKey))];
                        case 1:
                            _a.sent();
                            setShowNotificationBanner(NotificationStatus.SUCCESS);
                            setEditEnabled(false);
                            return [2 /*return*/];
                    }
                });
            }); }
        }
    });
    var isLoading = updateMarketingPreference.isLoading;
    var _e = useState(marketingSettingsData), currentMarketingPreferences = _e[0], setCurrentMarketingPreferences = _e[1];
    var getEnrollment = function (pref) {
        var _a;
        var preferenceIndex = currentMarketingPreferences === null || currentMarketingPreferences === void 0 ? void 0 : currentMarketingPreferences.findIndex(function (preference) { return (preference === null || preference === void 0 ? void 0 : preference.preferenceType) === pref; });
        return (_a = currentMarketingPreferences[preferenceIndex]) === null || _a === void 0 ? void 0 : _a.enrolled;
    };
    var dataType = getCamelCaseToSeparatedWords(categoryKey);
    var dataChannels = "enroll:".concat(currentMarketingPreferences
        .filter(function (pref) {
        return marketingPrivacySettingsCategories.marketingSettings.preferenceType.includes(pref.preferenceType) && pref.enrolled;
    })
        .map(function (pref) { return "".concat(pref.preferenceType.toLocaleLowerCase()); })
        .join('|'));
    var dataEnroll = categoryKey === PreferenceCategories.PRIVACY_SETTINGS &&
        "checkbox:".concat(getEnrollment(PreferenceType.PRIVACY)
            ? PrivacySettings.ON
            : PrivacySettings.OFF);
    var currentLanguage = SyfStorage.getLanguage();
    var t = useTranslation().t;
    var SAVE_I18N = t('buttonLabels.save');
    var CANCEL_I18N = t('buttonLabels.cancel');
    var EDIT_I18N = t('buttonLabels.edit');
    var ACKNOWLEDGE_LABEL = t('privacySettings.acknowledgeLabel');
    var SUCCESS_CONTENT = t('marketingPrivacySettings.successMessage');
    var ERROR_CONTENT = t('marketingPrivacySettings.errorMessage');
    var onEdit = function () {
        setEditEnabled(true);
        setShowNotificationBanner(null);
    };
    var onCancel = function () {
        setEditEnabled(false);
        setCurrentMarketingPreferences(marketingSettingsData);
        if (showNotificationBanner === NotificationStatus.ERROR)
            setShowNotificationBanner(null);
    };
    var onSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedMarketingPreference, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedMarketingPreference = getUpdatedPreferenceData(marketingSettingsData, currentMarketingPreferences);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateMarketingPreference.mutateAsync({
                            marketingPreferences: updatedMarketingPreference
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setShowNotificationBanner(NotificationStatus.ERROR);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var deliveryChangeHandler = function (preferenceType) {
        var _a;
        var updatedMarketingPreferences = __spreadArray([], currentMarketingPreferences, true);
        var selectedIndex = updatedMarketingPreferences.findIndex(function (preferenceData) { return (preferenceData === null || preferenceData === void 0 ? void 0 : preferenceData.preferenceType) === preferenceType; });
        var changedEnrollment = !((_a = updatedMarketingPreferences[selectedIndex]) === null || _a === void 0 ? void 0 : _a.enrolled);
        var preferenceDataForSelectedDeliveryMethod = __assign(__assign({}, updatedMarketingPreferences[selectedIndex]), { enrolled: changedEnrollment });
        updatedMarketingPreferences[selectedIndex] =
            preferenceDataForSelectedDeliveryMethod;
        setCurrentMarketingPreferences(updatedMarketingPreferences);
    };
    return (_jsxs("div", __assign({ "data-test": "MarketingPreferenceBody" }, { children: [showNotificationBanner && (_jsxs(_Fragment, { children: [_jsx(NotificationStatusBar, { type: showNotificationBanner, title: showNotificationBanner === NotificationStatus.SUCCESS
                            ? SUCCESS_CONTENT
                            : ERROR_CONTENT, icon: _jsx(NotificationBarIcon, { type: showNotificationBanner, icon: showNotificationBanner === NotificationStatus.SUCCESS
                                ? FAL_CHECK_CIRCLE
                                : FAS_CIRCLE_EXCLAMATION, size: "xl" }) }), _jsx(Stack, { size: "base" })] })), _jsx(PreferenceBodyContent, { categoryKey: categoryKey, marketingSettings: currentMarketingPreferences, isEditEnabled: isEditEnabled }), categoryKey === PreferenceCategories.MARKETING_SETTINGS && (_jsx(DeliveryMethodWrapper, __assign({ "$isEditEnabled": isEditEnabled, lang: currentLanguage }, { children: currentMarketingPreferences
                    .filter(function (preference) {
                    return marketingPrivacySettingsCategories[categoryKey].preferenceType.includes(preference.preferenceType);
                })
                    .map(function (_a) {
                    var preferenceType = _a.preferenceType, enrolled = _a.enrolled;
                    return (_jsx(DeliveryIcons, __assign({ icon: _jsx(ChipIcon, { icon: getDeliveryIcon(enrolled, isEditEnabled), height: "24px", "$isEnrolled": enrolled, "$isEditEnabled": isEditEnabled }), iconLeft: true, "$isEnrolled": enrolled, "$isEditEnabled": isEditEnabled, lang: currentLanguage, onClick: function () { return deliveryChangeHandler(preferenceType); }, disabled: !isEditEnabled }, { children: getDeliveryMethodTitle(preferenceType) }), preferenceType));
                }) }))), categoryKey === PreferenceCategories.PRIVACY_SETTINGS &&
                isEditEnabled && (_jsx(CustomCheckBox, __assign({ isChecked: getEnrollment(PreferenceType.PRIVACY), isDisabled: false, onChange: function () { return deliveryChangeHandler(PreferenceType.PRIVACY); }, isLabelOnLeft: false, "data-analytics": CLICK_TRACKING_EVENT, "data-reason": DATA_REASON.PRIVACY_CHECKBOX, "data-object": getEnrollment(PreferenceType.PRIVACY)
                    ? DATA_OBJECT.CHECKBOX.CHECKED
                    : DATA_OBJECT.CHECKBOX.UNCHECKED, "data-type": DATA_TYPE.PRIVACY_SETTINGS, "data-test": "PrivacyCheckbox" }, { children: ACKNOWLEDGE_LABEL }))), _jsx(ButtonWrapper, { children: !isEditEnabled ? (_jsx(CustomButton, __assign({ buttonType: "primary", onClick: onEdit, "data-analytics": CLICK_TRACKING_EVENT, "data-reason": DATA_REASON.EDIT, "data-object": DATA_OBJECT.BUTTON, "data-type": dataType, "data-channels": " " }, { children: EDIT_I18N }))) : (_jsxs(ButtonContainer, { children: [_jsx(CustomButton, __assign({ buttonType: "text", type: "button", onClick: onCancel, "data-analytics": CLICK_TRACKING_EVENT, "data-object": DATA_OBJECT.BUTTON, "data-reason": DATA_REASON.CANCEL, "data-type": dataType }, (dataEnroll
                            ? { 'data-enroll': dataEnroll }
                            : { 'data-channels': dataChannels }), { children: CANCEL_I18N })), _jsx(CustomButton, __assign({ buttonType: "primary", onClick: onSave, disabled: ((_b = getUpdatedPreferenceData(marketingSettingsData, currentMarketingPreferences)) === null || _b === void 0 ? void 0 : _b.length) < 1 || isLoading, "data-analytics": CLICK_TRACKING_EVENT, "data-object": DATA_OBJECT.BUTTON, "data-reason": DATA_REASON.SAVE, "data-type": dataType }, (dataEnroll
                            ? { 'data-enroll': dataEnroll }
                            : { 'data-channels': dataChannels }), { children: _jsx(ContentOrSpinner, { translation: SAVE_I18N, isLoading: isLoading, currentButtonClicked: SAVE_I18N }) }))] })) }), _jsx("div", {})] })));
};
export default MarketingPreferenceBody;
